import { createFileRoute } from '@tanstack/react-router';
import { UserTemplatesView } from '@/components/templates/UserTemplatesView';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/templates/my')({
  component: MyTemplatesPage,
});

function MyTemplatesPage() {
  return <UserTemplatesView mode="my" />;
}
